/*
 * @Descripttion: 短信消耗记录营销短信发送明细
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Balloon, Button, DatePicker, Form, Input, Table } from '@alifd/next';
import LzPagination from '@/components/common/LzPagination';
import LzMsg from '@/components/common/LzMsg';
import styles from './index.module.scss';
import { Servlets } from '@/service';
import utils from '@/common/utils';

function MarketSendDetail({ startTime = '', endTime = '', smsTaskType = '' }) {
  const [isLoading, setLoading] = useState(false);
  // form查询条件
  const [formValues, setFormValues] = useState({
    startTime,
    endTime,
    name: '',
  });

  // 分页数据
  const [pageInfo, setPageInfo] = useState({
    pageNo: 1,
    pageSize: 10,
    total: 0,
  });

  const [tabledata, setTableData] = useState([]);

  const changeTime = (val) => {
    let startT;
    let endT;
    startT = val[0] ? moment(val[0]).format('YYYY-MM-DD') : '';
    endT = val[1] ? moment(val[1]).format('YYYY-MM-DD') : '';
    setFormValues({ ...formValues, startTime: startT, endTime: endT });
  };

  /**
   * 重置筛选数据
   */
  const resetFilter = () => {
    setFormValues({
      ...formValues,
      startTime: '',
      endTime: '',
      name: '',
    });
    searchList({ pageNo: 1, pageSize: pageInfo.pageSize, startTime: '', endTime: '', name: '' });
  };

  /**
   * 查询短信列表记录
   */
  const searchList = (v) => {
    setLoading(true);
    const params = {
      functionType: 1,
      smsTaskType,
      startTime: formValues.startTime ? moment(`${formValues.startTime} 00:00:00`).valueOf() : '',
      endTime: formValues.endTime ? moment(`${formValues.endTime} 23:59:59`).valueOf() : '',
      name: formValues.name,
      pageNo: pageInfo.pageNo,
      pageSize: pageInfo.pageSize,
      ...v,
    };
    Servlets('getConsumptionDetail', params).then((res) => {
      if(res.success) {
        setTableData(res.data);
        setPageInfo({
          ...pageInfo,
          pageNo: res.page?.pageNo || pageInfo.pageNo,
          pageSize: res.page?.pageSize || pageInfo.pageSize,
          total: res.page.total,
        });
        setLoading(false);
      } else {
        LzMsg.error(res.resp_msg);
      }
    }).catch((e) => {
      console.log(e);
      setLoading(false);
    });
  };

  /**
   * 翻页方法
   */
  const handlePageSizeChange = async (pages = {}) => {
    setLoading(true);
    try {
      searchList({ pageNo: pages.pageNo, pageSize: pages.pageSize });
    } catch (e) {
      setLoading(false);
      LzMsg.error(e.message);
    }
  };

  /**
   * 导出exl
   */
  const exportExl = () => {
    if (tabledata.length) {
      Servlets('exportConsumptionDetail', {
        functionType: 1,
        smsTaskType,
        startTime: formValues.startTime,
        endTime: formValues.endTime,
        name: formValues.name,
      }).then((res) => {
        utils.downloadFile(res);
      })
    } else {
      LzMsg.error('数据为空，请切换查询条件后重试');
    }
  };

  useEffect(() => {
    searchList();
  }, []);

  return (
    <div >
      <Form>
        <div className={styles['search-big-box']}>
          <div className={styles['search-box']}>
            <span>发送时间：</span>
            <Form.Item>
              <DatePicker.RangePicker
                value={[formValues.startTime, formValues.endTime]}
                onChange={changeTime}
                style={{ width: '250px' }}
              />
            </Form.Item>
          </div>
          <div className={styles['search-box']}>
            <span>活动名称：</span>
            <Form.Item>
              <Input
                hasClear
                placeholder="请输入活动名称"
                name="names"
                style={{ width: '250px' }}
                value={formValues.name}
                onChange={(val) => setFormValues({ ...formValues, name: val })}
              />
            </Form.Item>
          </div>
          <div className={styles['search-box1']}>
            <Button
              type="primary"
              className={`${styles.mr10} ${styles.w88}`}
              onClick={() => searchList({ pageNo: 1, pageSize: pageInfo.pageSize })}
            >查询
            </Button>
            <Button type="normal" className={`${styles.mr10} ${styles.w88}`} onClick={resetFilter}>重置</Button>
            <Button type="normal" className={styles.w88} onClick={exportExl}>导出</Button>
          </div>
        </div>
      </Form>
      <Table
        loading={isLoading}
        dataSource={tabledata}
        fixedHeader
        maxBodyHeight={(window.screen.height) * 0.6 - 180}
      >
        <Table.Column title="活动名称" dataIndex="activityTitle" key="activityTitle" />
        <Table.Column
          title="发送时间"
          dataIndex="sendTime"
          key="sendTime"
        />
        <Table.Column title="短信内容" dataIndex="fullContent" key="fullContent" />
        <Table.Column
          title={
            <div className={styles['tips-title']}>
              <div>实际触达人数/人</div>
              <Balloon.Tooltip
                popupClassName="popupClassName"
                align='t'
                trigger={<div className={`${styles['icon-style']} iconfont icon-icon4-33`} />}
              >
                只记录发送成功营销活动
              </Balloon.Tooltip>
            </div>
          }
          dataIndex="realNum"
          key="realNum"
          cell={(value, index, item) => (
            <span>{utils.numFormat(value)}</span>
          )}
        />
        <Table.Column
          title="字数/计费（条）"
          key="smsNum"
          cell={(value, index, item) => (
            <span
              // Bug 77035
              // style={{ color: '#ff3333' }}
            >{item.smsSplitNum}
            </span>
          )}
        />
        <Table.Column
          title="实际消耗总计（条）"
          key="actualSmsNum"
          cell={(value, index, item) => (
            <span>{utils.numFormat(item.actualSmsNum)}</span>
          )}
        />
        {/* <Table.Column
          title={
            <div className={styles['tips-title']}>
              <div>实际短信消耗量（条）</div>
              <Balloon.Tooltip
                popupClassName="popupClassName"
                align='t'
                trigger={<div className={`${styles['icon-style']} iconfont icon-icon4-33`}/>}
              >
                只记录发送成功营销活动
              </Balloon.Tooltip>
            </div>
          }
          dataIndex="jdActualNum"
          key="jdActualNum"
        /> */}
      </Table>
      <LzPagination pageInfo={pageInfo} onChange={handlePageSizeChange} />
    </div>
  );
}

export default MarketSendDetail;
